import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=56dd10de&scoped=true"
import script from "./NoteDialog.vue?vue&type=script&lang=js"
export * from "./NoteDialog.vue?vue&type=script&lang=js"
import style0 from "./NoteDialog.vue?vue&type=style&index=0&id=56dd10de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd10de",
  null
  
)

export default component.exports